import { useCallback, useMemo, useState } from "react";

export type AssetOption = { plantId?: string; plantName?: string; [key: string]: unknown };

const useSearchFilters = () => {
  const [searchString, setSearchString] = useState<string>('');
  const [selectedAssets, setSelectedAssets] = useState<AssetOption[]>([]);

  const handleSearch = useCallback((value: string) => {
    setSearchString(value);
  }, []);

  const handleAssetSelect = useCallback((value: any) => {
    if (!value) {
      setSelectedAssets([]);
      return;
    }
    const options = Array.isArray(value) ? value : [value];
    setSelectedAssets(options.filter((v): v is AssetOption => v != null && v?.plantId != null));
  }, []);

  const selectedAssetIds = useMemo(
    () => selectedAssets.map((a) => a.plantId).filter(Boolean) as string[],
    [selectedAssets]
  );

  return {
    searchString,
    handleSearch,
    selectedAssets,
    selectedAssetIds,
    handleAssetSelect,
  };
};

export default useSearchFilters;